import { useQuery } from '@apollo/client';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import React, { useEffect, useState } from 'react';
import { communities } from 'tf-post-parser';
import { GET_FOLLOWING } from '../../helpers/graphql/following';
import { getUser } from '../../helpers/token';
import Link from '@mui/material/Link';

const CommunitySidebar = ({ active }) => {
  const [myCommunities, setMyCommunities] = useState([]);
  const [moreCommunities, setMoreCommunities] = useState([]);
  const [langCommunities, setLangCommunities] = useState([]);
  const [user, setUser] = useState(null);

  useEffect(() => {
    setUser(getUser());
  }, []);

  const onCompleted = ({ following }) => {
    const myNewCommunities = [];
    const newMoreCommunities = [];
    const newLangCommunities = [];
    const myCommunityIds = [100037, 175111, 129292, 184437, 100705]; // ignored communities
    if (
      following &&
      following.communities &&
      following.communities.length > 0
    ) {
      following.communities.forEach(followedCommunity => {
        communities.forEach(community => {
          if (community.id === followedCommunity) {
            myCommunityIds.push(community.id);
            myNewCommunities.push(community);
          }
        });
      });
    }
    communities.forEach(community => {
      if (myCommunityIds.indexOf(community.id) === -1)
        if (community.lang === 'en') newMoreCommunities.push(community);
        else newLangCommunities.push(community);
    });
    setMyCommunities(myNewCommunities);
    setMoreCommunities(newMoreCommunities);
    setLangCommunities(newLangCommunities);
  };

  useQuery(GET_FOLLOWING, { onCompleted, ssr: false });

  if (
    user === null ||
    (myCommunities.length === 0 && moreCommunities.length === 0)
  )
    return <></>;

  const communityTitleToLanguage = {
    'PL-TravelFeed': 'Polish',
    'CN-TravelFeed': 'Chinese',
    'ES-TravelFeed': 'Spanish',
    'DE-TravelFeed': 'German',
    'IT-TravelFeed': 'Italian',
  };

  return (
    <>
      <List>
        <Typography variant="h6" className="pt-2 pl-3">
          International Communities
        </Typography>
        {langCommunities.map(community => (
          <Link
            color="textPrimary"
            href={`/communities/${community.id}`}
            key={community.id}
          >
            <ListItem selected={active === community.id}>
              <ListItemText
                primary={communityTitleToLanguage[community.title]}
              />
            </ListItem>
          </Link>
        ))}
        <Link color="textPrimary" href={`/communities/175111`} key={175111}>
          <ListItem selected={active === 175111}>
            <ListItemText primary="Other Languages" />
          </ListItem>
        </Link>
      </List>
    </>
  );
};
export default CommunitySidebar;
